export const environment = {
  "production": false,
  "stage": "DEV",
  "APP_URL": "https://detailyx-backoffice-prueba.ilimitec.com",
  "API_URL": "https://detailyx-backoffice-api-prueba.ilimitec.com",
  "MAPS_KEY": "",
  "MAP_ID": ""
} as const;
